import { render } from "./AddNormlistModal.vue?vue&type=template&id=06624a6f&ts=true"
import script from "./AddNormlistModal.vue?vue&type=script&lang=ts"
export * from "./AddNormlistModal.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__